export const NUMBERS_VIEW_PATH = "/numbers/:accountUuid/:principalUuid";
export const NUMBER_DETAIL_VIEW_PATH =
  "/numbers/:accountUuid/:principalUuid/:smppConfigUuid";
export const NUMBER_CREATE_VIEW_PATH =
  "/numbers/:accountUuid/:principalUuid/create";
export const NUMBER_EDIT_VIEW_PATH =
  "/numbers/:accountUuid/:principalUuid/:smppConfigUuid/edit";
